import {useQuery} from "@tanstack/react-query";
import {readProductIn} from "../../../../../api/product/ProductInApi";
import {ProductInSearchParamType} from "../interface";
import {productInListMapInit} from "../state";

type Props = {
    param: ProductInSearchParamType;
};

export const useReadProductIn = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readProductIn", param],
        queryFn: async () => await readProductIn(param),
        select: (res) => res?.data.result ?? productInListMapInit,
    });

    return {data};
};
